/**
 * @generated SignedSource<<75f9863bec5f28a8ce7ba11a4b5058de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeetingAuditQuery$variables = {};
export type MeetingAuditQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly hasMeetingAuditLog: boolean;
      readonly integrations: {
        readonly gsuite: {
          readonly delegated: boolean;
          readonly id: string;
        } | null;
        readonly office365: {
          readonly adminConsented: boolean;
          readonly id: string;
          readonly signedAccountIdUrl: string | null;
        } | null;
      };
    };
  };
};
export type MeetingAuditQuery = {
  response: MeetingAuditQuery$data;
  variables: MeetingAuditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMeetingAuditLog",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GSuiteAccountNode",
      "kind": "LinkedField",
      "name": "gsuite",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delegated",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfficeAccountNode",
      "kind": "LinkedField",
      "name": "office365",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminConsented",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signedAccountIdUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingAuditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeetingAuditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "684949d5c55569bf5c2b56d66c4dc5ba",
    "id": null,
    "metadata": {},
    "name": "MeetingAuditQuery",
    "operationKind": "query",
    "text": "query MeetingAuditQuery {\n  viewer {\n    account {\n      hasMeetingAuditLog\n      integrations {\n        gsuite {\n          id\n          delegated\n        }\n        office365 {\n          id\n          adminConsented\n          signedAccountIdUrl\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "58c275fd3e0f305d8419cc5ae63b8d99";

export default node;
